const DEFAULT_HTML_FONT_SIZE = 16;

export function pxToRem(px: number): string {
	return `${px / DEFAULT_HTML_FONT_SIZE}rem`;
}
